export default __webpack_public_path__ + "static/media/img1.15bdc502.webp";